import React, { Component } from 'react';
import Nav from '../components/Nav';
import PostForm from '../components/PostForm';
import { database, auth } from '../firebase';

class CreatePost extends Component {

componentWillMount() {
  auth.onAuthStateChanged(function(user) {
    if (user === null) return window.location.pathname = "/giris-yap";
    database.ref("users/" + user.uid).on(`value`, snap => {
      if (snap.val().verified === undefined) return window.location.pathname = "/";
    })
  });
}

render() {return (
    <>
      <Nav/>

      <div className="main">
        <PostForm/>
      </div>

      <style>{`
        .main {
          margin-top: 49px;
        }

        @media (max-width: 900px) {
          .main {
            margin: 0;
          }
        }
        
        @media (max-width: 623px) {
          .main {
            margin: 0;
            padding-bottom: 42px;
          }

          footer {
            margin: 0;
          }
        }
      `}</style>
  </>
)}};

export default CreatePost;